import Line from './line';
import './styles.css';

export default function Lines({lines}) {
  return (
    <div className="summary-lines">
      {
        lines.map((line, index) => (
          <Line key={index} label={line.label} value={line.value} firstAttemptValue={line.firstAttemptValue} />
        ))
      }
    </div>
  );
}
